/**
 * Theme Name: project-sscms v1.511.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - 1f45cce37]
 * Version: 1.511.0-2025-07-18T18-36-12
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
/**
 * referral.js
 */

const referralType = 'raf';
const referralPath = window.location.pathname.split('/');
const urlToken = referralPath[2] == 'a' ? referralPath[3] : referralPath[2];
const endpointRedirect = "/?ad=ch_raf&ch_rafid=" + urlToken;

// Start API call immediately
const apiPromise = callReferralApi(urlToken);

// hide loader, display hero content
function displayHeroContent() {
  // Get loader and hero copy to hide/display
  const loader = document.querySelector('.referral__loader');
  const heroCopy = document.querySelector('.referral__copy');
  
  (loader) ? loader.style.display = 'none' : null;
  (heroCopy) ? heroCopy.style.display = 'block' : null;
}

// append content
function appendContent(heading, subheading, fineprint = null, pill_text = null, bonus_amount = null) {
  const appendHeading = document.querySelector('.append-heading');
  const appendSubheading = document.querySelector('.append-subheading');
  const appendFineprint = document.querySelector('.append-fineprint');

  if (appendHeading) appendHeading.innerHTML = heading;
  if (appendSubheading) appendSubheading.innerHTML = subheading;
  if (fineprint && appendFineprint) appendFineprint.innerHTML = fineprint;
  // Show pill text and display alternative chime logo header
  if (pill_text) {
    document.querySelector('.append-pill').innerHTML = pill_text;
    document.querySelector('.referral__pill').style.display = 'flex';
    document.querySelector('.header__branding').style.display = 'none';
    document.querySelector('.header').style.display = 'block';
    if (bonus_amount) {
      const appendBonus = document.querySelectorAll('.append-bonus');
      for (let i = 0; i < appendBonus.length; i++) {
        appendBonus[i].textContent = bonus_amount;
      }
    }                         
  }
}

// display error content
function displayErrorContent(errorCode, referralType, endpointRedirect) {
  const loader = document.querySelector('.referral__loader');
  (loader) ? loader.style.display = 'none' : null;
  switch(errorCode) {
    case "404":
      appendContent("Uh-oh. The Invite Friends page you’re looking for isn’t here!", "Please check that the page URL is correct.");
      break;
    case "500":
      appendContent("Uh-oh. Something went wrong.", "Please try again later.");
      break;
    default:
      // Redirect to homepage but pass referral QSP
      endpointRedirectTrack('token', referralType, errorCode, 'Default error response', endpointRedirect);
  }
}

function displayReferralData(token, endpointRedirect, response) {
  // If data is not valid or does not contains referral_campaign, redirect to homepage but pass referral and boost anyone QSPs
  if (!response.data || !response.data.unauthenticated.referral.referral_campaign) {
    endpointRedirectTrack(token, referralType, null, 'No endpoint data returned', endpointRedirect);
  }

  if (response.data && response.data.unauthenticated.referral.referral_campaign) {
    const referral_campaign = response.data.unauthenticated.referral.referral_campaign;

    if (referral_campaign.__typename === 'GenericError') {
      displayError(referral_campaign.title, endpointRedirect);
      return;
    }

    const referralToken = referral_campaign.referral_token ?? token;
        
    // get data, append to hero elements
    const fine_print = referral_campaign.fine_print;
    const heading = referral_campaign.heading + '.';
    const sub_heading = referral_campaign.sub_heading;
    const id = referral_campaign.id;
    const pill_text = referral_campaign.pill_text || '';
    const bonus_amount = referral_campaign.bonus_amount || '';
    const referring_user = {
      id: referral_campaign.referring_user_id,
      name: referral_campaign.referring_user_name,
    };
    const incentive_name = btoa("Urgency Offer");
    const incentive_cohort_name = referral_campaign.urgency_offer_incentive_cohort_name || '';
    const receiver_incentive_ttl = referral_campaign.urgency_offer_receiver_inventive_ttl || '0';
    const incentive_fields = {incentive_name: incentive_name,
                              incentive_cohort_name: incentive_cohort_name,
                              receiver_incentive_ttl: receiver_incentive_ttl,
    };
    
    appendContent(heading, sub_heading, fine_print, pill_text, bonus_amount);

    displayHeroContent();
    if (document.cookie.indexOf("fpViewed") === -1) {fpViewedTrack(id, referring_user, "raf");}

    setReferrerCookie('referral_token', referralToken, referralType, null, referring_user.name, incentive_fields);
  }
}

function displayError(errorCode, endpointRedirect) {
  document.querySelector('.email-capture-wrapper').textContent = "";
  document.querySelector('.header__branding a').href = endpointRedirect;
  displayErrorContent(errorCode, referralType, endpointRedirect);
  displayHeroContent();
}

// Wait for both the DOM to be ready and the API call to complete before updating the DOM
document.addEventListener('DOMContentLoaded', function() {
  apiPromise.then(response => {
    displayReferralData(urlToken, endpointRedirect, response);
  }).catch(() => {
    displayError("500", endpointRedirect);
  });
});
